export const ITEM_LIMITATION = 3;


// WEBPACK FOOTER //
// ./src/common/constants/block-detail-sidebar.constant.ts